// Auto-generated by build-comment-action-sprite.js
export const SPRITE_VERSION = "704f268a";